export const MAIN_BENCHMARKS = [
  { label: 'CDI', value: 'cdi' },
  { label: 'IBOVESPA', value: 'ibov' },
  { label: 'IPCA', value: 'ipca' },
  { label: 'POUPANÇA', value: 'poup' },
];

export const BENCHMARKS_SELECT = [
  { label: 'CDI', value: 'cdi' },
  { label: 'IBOVESPA', value: 'ibov' },
  { label: 'IPCA', value: 'ipca' },
  { label: 'POUPANÇA', value: 'poup' },
  { label: 'IBOVESPA DOLARIZADO', value: 'ibov-usd' },
  { label: 'IBRX BRASIL', value: 'ibxx' },
  { label: 'IFIX', value: 'ifix' },
  { label: 'IMA-B', value: 'ima-b' },
  { label: 'IHFA', value: 'ihfa' },
  { label: 'SELIC', value: 'selic' },
  { label: 'IGP-M', value: 'igp-m' },
  { label: 'IRF-M', value: 'irf-m' },
  { label: 'IDIV', value: 'idiv' },
  { label: 'SMLL', value: 'smll' },
  { label: 'DÓLAR', value: 'dolar' },
  { label: 'S&P 500', value: 'sp500-tr' },
  { label: 'S&P 500 em BRL', value: 'sp500-brl' },
];

export const INDEX_COLORS = {
  cdi: '#0000E0',
  CDI: '#0000E0',
  ibov: '#D47500',
  IBOVESPA: '#D47500',
  'IBOV - INDICE BOVESPA': '#D47500',
  'IBOV - INDICE BOVESPA                ': '#D47500',
  'ibov-usd': '#d44700',
  'IBOVESPA DOLARIZADO': '#d44700',
  'IBOVESPA USD': '#d44700',
  'ipca-proj': '#DB0A5B',
  ipca: '#DB0A5B',
  IPCA: '#DB0A5B',
  poup: '#600060',
  POUPANÇA: '#600060',
  selic: '#00AA00',
  SELIC: '#00AA00',
  dolar: '#527AC2',
  DÓLAR: '#527AC2',
  ibxx: '#939393',
  'IBRX BRASIL': '#939393',
  'ima-b': '#6B8E23',
  'IMA-B': '#6B8E23',
  ihfa: '#FF00FF',
  IHFA: '#FF00FF',
  'igp-m': '#8D6708',
  'igp-m-projecao-anbima': '#8D6708',
  'IGP-M projeção Anbima': '#8D6708',
  'IGP-M': '#8D6708',
  'irf-m': '#E26A6A',
  'IRF-M': '#E26A6A',
  idiv: '#1D781D',
  IDIV: '#1D781D',
  smll: '#545454',
  'SMALL CAP': '#545454',
  sp500: '#8778E8',
  'sp500-tr': '#8778E8',
  'S&P 500 - Total Return': '#8778E8',
  'sp500-brl': '#009739',
  'S&P 500 em BRL': '#009739',
  IFIX: '#528d8d',
  ifix: '#528d8d',
};

export const INDEX_TICKER_TO_NAME = {
  cdi: 'CDI',
  ibov: 'IBOVESPA',
  ibxx: 'IBRX BRASIL',
  'ibov-usd': 'IBOVESPA DOLARIZADO',
  'ima-b': 'IMA-B',
  ihfa: 'IHFA',
  selic: 'SELIC',
  'ipca-proj': 'IPCA',
  ipca: 'IPCA',
  'igp-m': 'IGP-M',
  'igp-m-projecao-anbima': 'IGP-M',
  poup: 'POUPANÇA',
  'irf-m': 'IRF-M',
  idiv: 'IDIV',
  smll: 'SMALL CAP',
  dolar: 'DÓLAR',
  'sp500-tr': 'S&P 500',
  'sp500-brl': 'S&P 500 em BRL',
  ifix: 'IFIX',
};
